import React from 'react';
import Uganda1_subjects from './uganda1_subjects';

const Uganda1 = () => {
  return (
    <div>
      <Uganda1_subjects />
    </div>
  );
}

export default Uganda1;
